<script setup lang="ts">
import { ref } from 'vue';
import { useSearchContext } from '../composables/searchContext';
import type { SeriesFacet } from '../models/FacetModels';
const props = defineProps<{ facet: SeriesFacet }>();
const search = useSearchContext();
const expanded = ref(props.facet.IsCurrent === 'Y');
</script>

<template>
  <section v-if="!(facet.SeriesName === 'State' && search.countryCode.value === 'NZ') && facet.SeriesFacetCount > 0" class="series-facet-home">
    <div class="series-facet-headerbody">
      <button type="button" class="series-facet-header" :class="{ 'series-facet-header-active': facet.IsCurrent === 'Y' }" @click="search.selectSeries(facet.SeriesAttributeTypeSk, facet.SeriesAttributeTypeValueSk)">{{ facet.SeriesName }} ({{ facet.SeriesFacetCount }})</button>
      <button v-if="facet.SetFacet.length" type="button" class="cleartxt fa-solid" :class="expanded ? 'fa-chevron-down' : 'fa-chevron-right'" :aria-expanded="expanded" :aria-label="`Toggle ${facet.SeriesName} sets`" @click="expanded = !expanded"></button>
    </div>
    <div v-show="expanded" class="facet-body facet-open">
      <button v-for="child in facet.SetFacet.filter((item) => item.SetProductCount > 0)" :key="child.AttributeTypeValueSk" type="button" class="series-facet-child" :class="{ 'series-facet-child-active': child.IsSelected === 'Y' }" @click="search.selectSeries(child.AttributeTypeSk, child.AttributeTypeValueSk)">
        <span class="series-facet-childname">{{ child.AttributeType }}</span><span class="series-facet-childbody">({{ child.SetProductCount }})</span>
      </button>
    </div>
  </section>
</template>
